import { render, staticRenderFns } from "./LevelItem.vue?vue&type=template&id=32428870&"
import script from "./LevelItem.vue?vue&type=script&lang=js&"
export * from "./LevelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports